import logo from "../../../../public/projects/Mahindra/images/logo/logo.png";
import happinest from "../../../../public/projects/Mahindra/images/projects/h.jpg"
export const developersMahindra = {
  name: `Mahindra Lifespaces Properties in Mumbai`,
  properties: [
    {
      name: "Mahindra Happinest Kalyan",
      image:happinest,
      price: "On Request",
      state:"Mumbai",
      developer:"Mahindra",
      location: "Mumbai",
      bed: "1.5 & 2 BHK ",
      size: "....",
      url: ``,
      form:{
        source_id:11,
        api_userPublicKey:`hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
        api_userSecretKey:`jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
        sub_source_id:130,
        builder_id:`103`,
        project_id:`477`,
        subject: "M3M Altitude", // Add or update the subject here
        to_email: "jatin.rohilla@propertystation.in",
      }
    },
  ],
};
export const Headers = {
  logo: logo,
  data: {
    experience: "1994",
  },
  about: `
  Mahindra Lifespace Developers Ltd. is an Indian real estate and infrastructure development
   company headquartered in Mumbai, India. The company was founded in 1994 and is part of the 
   Mahindra Group.The company is engaged in residential developments under the Mahindra Lifespaces and
    Happinest brands; and integrated cities and industrial clusters under the Mahindra World City and ORIGINS 
    by Mahindra World City brands. The company has developed properties in Mumbai, Pune, Nagpur, Ahmedabad, Delhi 
    NCR, Jaipur, Hyderabad, Chennai, and Bengaluru. `,
};
